import { RefreshCw, TriangleAlert } from 'lucide-react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { NotFoundPage } from './NotFoundPage';

/** A lazy chunk that no longer exists after a deploy fails with these messages. */
function isChunkError(error: unknown): boolean {
  return (
    error instanceof Error &&
    /dynamically imported module|Importing a module script failed|Failed to fetch|error loading/i.test(
      error.message,
    )
  );
}

/** Error boundary of the routes: 404, new version deployed, unexpected errors. */
export function RouteErrorPage() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  const chunk = isChunkError(error);
  return (
    <div className="p-4">
      <EmptyState
        icon={TriangleAlert}
        title={chunk ? 'È disponibile una nuova versione' : 'Si è verificato un errore'}
        description={
          chunk
            ? 'Questa pagina non è più disponibile nella versione in uso. Ricarica per aggiornare l’app (i dati non inviati restano sul dispositivo).'
            : 'La pagina non può essere mostrata. Ricarica; se il problema continua avvisa un responsabile FMF.'
        }
        action={
          <Button onClick={() => window.location.reload()}>
            <RefreshCw /> Ricarica
          </Button>
        }
      />
    </div>
  );
}
